__turbopack_context__.v({
  "listItemLabel": "mantineList-module-scss-module__ElPL5a__listItemLabel",
  "listItemWrapper": "mantineList-module-scss-module__ElPL5a__listItemWrapper",
  "listRoot": "mantineList-module-scss-module__ElPL5a__listRoot",
});
